// extracted by mini-css-extract-plugin
export default {"root":"activity-header_root__vuPY-","row":"activity-header_row__57gIg"};